module.exports = __webpack_public_path__ + "img/link_black.464c9323.svg";